var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6199 5.50894L12.6049 5.5L15.6898 22.2406L17.4188 11.6333L17.6457 10.2416L18.3462 11.4653L20.0056 14.3638H27V15.3638H19.7157H19.4258L19.2818 15.1122L18.1789 13.1858L16.2134 25.2438L15.2282 25.254L12.1395 8.49249L10.5202 18.2725L10.2393 19.9685L9.56673 18.3864L8.2817 15.3638H2V14.3638H8.61245H8.94319L9.07259 14.6682L9.81441 16.4131L11.6199 5.50894Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressStatus);
export default __webpack_public_path__ + "static/media/ProgressStatus.2c2825cda70429d78e358da3e829b8da.svg";
export { ForwardRef as ReactComponent };